import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
    colname0: null,
    colname1: null,
    conditionSet: null,
    selectmasterId: null,
    selectedEntity: null,
    firstlevel:false,
    masterName:null
}
const entitySlice = createSlice({
    name: 'Entites',
    initialState,
    reducers: {
        setcolName(state, action) {
            state.colname0 = action.payload;
        },
        setfirstLevel(state, action) {
            state.firstlevel = action.payload;
        },
        setcol1name(state, action) {
            state.colname1 = action.payload;
        },
        setMasterID(state, action) {
            state.selectmasterId = action.payload;
        },
        setSelectedEntity(state, action) {
            state.selectedEntity = action.payload;
        },
        setConditionSet(state, action) {
            state.conditionSet = action.payload;
        },
        setMasterName(state, action) {
            state.masterName = action.payload;
        },
       
    }
})
export const {
    setcolName,
    setfirstLevel,
    setcol1name,
    setMasterID,
    setSelectedEntity,
    setConditionSet,
    setMasterName,
} = entitySlice.actions;

export default entitySlice.reducer;
